/* eslint-disable @typescript-eslint/naming-convention */
export class OfficeUpdatePictureFormData {
  private formData: FormData;
  private OFFICE_PICTURE_RANK = 1;

  constructor(
    image?: Blob,
    rank?: number,
    signaturePictureDefault?: boolean,
    scellementPicture?: boolean,
  ) {
    this.formData = new FormData();

    this.formData.append("picture", image || "none");

    this.formData.append("rank", `${rank ? rank : this.OFFICE_PICTURE_RANK}`);

    if (signaturePictureDefault !== undefined) {
      this.formData.append(
        "signaturePictureDefault",
        signaturePictureDefault.toString(),
      );
    }

    if (scellementPicture !== undefined) {
      this.formData.append("scellementPicture", scellementPicture.toString());
    }
  }

  appendFile(key: "picture", value: Blob): void {
    this.formData.append(key, value);
  }

  appendString(
    key: "rank" | "signaturePictureDefault" | "scellementPicture",
    value: string,
  ): void {
    this.formData.append(
      key,
      new Blob([value.toString()], {
        type: "application/json",
      }),
    );
  }

  getKey(
    key: "picture" | "key" | "signaturePictureDefault" | "scellementPicture",
  ): FormDataEntryValue | null {
    return this.formData.get(key);
  }

  get(): FormData {
    return this.formData;
  }
}
